import { isDefined } from "@clipboard-health/util-ts";
import { type TimeRange } from "@src/appV2/Shifts/Shift/types";
import { differenceInMinutes, parseISO } from "date-fns";

/**
 * Returns the actual duration that a shift was worked in minutes.
 * This calculates the time from clock in to clock out, minus any lunch break time.
 */
export function getShiftClockedInDurationInMinutes(
  clockInOut: TimeRange,
  lunchInOut?: TimeRange
): number | undefined {
  if (!isDefined(clockInOut.start) || !isDefined(clockInOut.end)) {
    return undefined;
  }

  const totalClockedInMinutes = differenceInMinutes(
    parseISO(clockInOut.end),
    parseISO(clockInOut.start)
  );

  // Calculate lunch break duration if applicable
  let lunchBreakMinutes = 0;
  if (isDefined(lunchInOut?.start) && isDefined(lunchInOut?.end)) {
    lunchBreakMinutes = differenceInMinutes(parseISO(lunchInOut.end), parseISO(lunchInOut.start));
  }

  return totalClockedInMinutes - lunchBreakMinutes;
}

/**
 * Returns the actual duration that a shift was worked in hours.
 * This calculates the time from clock in to clock out, minus any lunch break time.
 */
export function getShiftClockedInDurationInHours(
  clockInOut: TimeRange,
  lunchInOut?: TimeRange
): number | undefined {
  const durationInMinutes = getShiftClockedInDurationInMinutes(clockInOut, lunchInOut);

  if (!isDefined(durationInMinutes)) {
    return undefined;
  }

  return Math.round((durationInMinutes / 60) * 100) / 100;
}
